import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "../styles/Client.css";

import clientBanner from "../assets/images/client-banner.jpg";

import CIT from "../assets/images/cit-logo.jpeg";
import MMSR from "../assets/images/mmsr-logo.jpeg";
import SUN from "../assets/images/sunemirates-logo.png";

function Client() {

  const clients = [
    {
      name: "MMSR",
      role: "Strategic Partner",
      logo: MMSR,
      desc:
        "MMSR collaborates with CEITCS to deliver innovative technology solutions and strategic digital transformation services."
    },
    {
      name: "Coimbatore Institute of Technology",
      role: "Academic Partner",
      logo: CIT,
      desc:
        "CIT partners with CEITCS to bridge academia and industry by promoting research, innovation, and practical technology learning."
    },
    {
      name: "Sunemirates",
      role: "Technology Client",
      logo: SUN,
      desc:
        "Sunemirates works with CEITCS to implement reliable IT solutions, cloud services, and business process automation."
    }
  ];

  const [feedbacks, setFeedbacks] = useState({});
  const [loading, setLoading] = useState({});

  const handleChange = (index, field, value) => {
    setFeedbacks({
      ...feedbacks,
      [index]: {
        ...feedbacks[index],
        [field]: value
      }
    });
  };

  const handleSubmit = async (index) => {

    const client = clients[index];

    const feedbackData = {
      clientName: client.name,
      feedback: feedbacks[index]?.feedback || "",
      rating: Number(feedbacks[index]?.rating || 0),
    };

    if (
      !feedbackData.feedback ||
      feedbackData.rating < 1 ||
      feedbackData.rating > 5
    ) {
      alert("Please enter valid feedback and rating (1-5).");
      return;
    }

    try {

      setLoading({
        ...loading,
        [index]: true
      });

      const API_URL =
        process.env.REACT_APP_API_URL ||
        "http://localhost:5000";

      const res = await axios.post(
        `${API_URL}/api/client-feedback`,
        feedbackData
      );

      alert(res.data.message);

      setFeedbacks({
        ...feedbacks,
        [index]: {
          feedback: "",
          rating: ""
        }
      });

      setLoading({
        ...loading,
        [index]: false
      });

    } catch (err) {

      console.error(err);

      alert("Error submitting feedback");

      setLoading({
        ...loading,
        [index]: false
      });

    }

  };
    return (
    <>
      {/* ================= HERO SECTION ================= */}
      <section
        className="client-hero"
        style={{ backgroundImage: `url(${clientBanner})` }}
      >
        <div className="client-overlay"></div>

        <div className="hero-content">
          <h1>Our Clients</h1>

          <p>
            <Link to="/home">Home</Link> » <span>Clients</span>
          </p>
        </div>
      </section>

      {/* ================= CLIENT PAGE ================= */}

      <div className="client-page">

        <h2 className="client-title">
          Trusted by Leading Organizations
        </h2>

        <p className="client-subtitle">
          We collaborate with educational institutions and
          businesses to deliver innovative technology solutions,
          digital transformation, cloud services, AI, and
          enterprise consulting.
        </p>

        <div className="client-container">

          {clients.map((client, index) => (

            <div
              key={index}
              className="client-card"
            >

              <div className="client-avatar">
                <img
                  src={client.logo}
                  alt={client.name}
                />
              </div>

              <h3>{client.name}</h3>

              <p className="client-role">
                {client.role}
              </p>

              <p className="client-desc">
                {client.desc}
              </p>

              {/* ================= FEEDBACK ================= */}

              <div className="client-feedback-box">

                <input
                  type="text"
                  placeholder="Write your feedback..."
                  value={
                    feedbacks[index]?.feedback || ""
                  }
                  onChange={(e) =>
                    handleChange(
                      index,
                      "feedback",
                      e.target.value
                    )
                  }
                />

                <input
                  type="number"
                  placeholder="Rating (1-5)"
                  min="1"
                  max="5"
                  value={
                    feedbacks[index]?.rating || ""
                  }
                  onChange={(e) =>
                    handleChange(
                      index,
                      "rating",
                      e.target.value
                    )
                  }
                />

                <button
                  onClick={() =>
                    handleSubmit(index)
                  }
                  disabled={loading[index]}
                >
                  {loading[index]
                    ? "Submitting..."
                    : "Submit Feedback"}
                </button>

              </div>

            </div>

          ))}

        </div>

      </div>
    </>
  );
}

export default Client;